import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-3ab005d7")
const _hoisted_1 = { class: "lg:container lg:mx-auto pt-8" }
const _hoisted_2 = { class: "grid grid-cols-1 lg:grid-cols-3 lg:grid-rows-8 lg:grid-flow-col gap-y-2 gap-x-0 lg:gap-x-8" }
const _hoisted_3 = { class: "col-span-2 dark:bg-gray-850 height-80 flex items-center order-2 lg:order-1" }
const _hoisted_4 = {
  key: 1,
  class: "px-4 lg:px-0 flex flex-col padding-20"
}
const _hoisted_5 = { class: "flex flex-wrap items-center lg:-mt-2 height-80" }
const _hoisted_6 = { class: "w-full lg:w-auto font-ops pool-title" }
const _hoisted_7 = { class: "ml-2 token-symbol" }
const _hoisted_8 = {
  key: 0,
  class: "division ml-2"
}
const _hoisted_9 = { class: "col-span-2 row-span-3 order-3 lg:order-1" }
const _hoisted_10 = { class: "grid grid-cols-1 gap-y-8 bg-gray-850 p-4 my-2" }
const _hoisted_11 = { class: "px-1 lg:px-0" }
const _hoisted_12 = { class: "grid grid-cols-1 gap-y-8 bg-gray-850 p-4" }
const _hoisted_13 = { class: "px-1 lg:px-0" }
const _hoisted_14 = {
  key: 0,
  class: "order-1 lg:order-2 px-1 lg:px-0 row-span-6"
}
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BalLoadingBlock = _resolveComponent("BalLoadingBlock")!
  const _component_BalAssetSet = _resolveComponent("BalAssetSet")!
  const _component_BalAlert = _resolveComponent("BalAlert")!
  const _component_FarmPoolStatCards = _resolveComponent("FarmPoolStatCards")!
  const _component_FarmAction = _resolveComponent("FarmAction")!
  const _component_FarmNavCard = _resolveComponent("FarmNavCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.loadingPool)
          ? (_openBlock(), _createBlock(_component_BalLoadingBlock, {
              key: 0,
              class: "h-16 height-80"
            }))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("h3", _hoisted_6, [
                  _createVNode(_component_BalAssetSet, {
                    addresses: _ctx.orderedTokenAddressesFor(_ctx.pool),
                    width: 100,
                    size: 32
                  }, null, 8, ["addresses"])
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.titleTokens, ([, tokenIndo], i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: i,
                    class: "mt-2 flex items-center h-10 bg-gray-50 dark:bg-gray-850 rounded-lg"
                  }, [
                    _createElementVNode("span", _hoisted_7, _toDisplayString(tokenIndo.symbol), 1),
                    (i < _ctx.titleTokens.length - 1)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_8, " / "))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ])
            ])),
        (!_ctx.appLoading && _ctx.noInitLiquidity)
          ? (_openBlock(), _createBlock(_component_BalAlert, {
              key: 2,
              type: "warning",
              title: _ctx.$t('noInitLiquidity'),
              description: _ctx.$t('noInitLiquidityDetail'),
              class: "mt-2",
              block: ""
            }, null, 8, ["title", "description"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_FarmPoolStatCards, {
              pool: _ctx.pool,
              loading: _ctx.loadingPool,
              userPools: _ctx.userPools,
              userClaimFlakeStatus: _ctx.userClaimFlakeStatus,
              farmId: _ctx.farmId
            }, null, 8, ["pool", "loading", "userPools", "userClaimFlakeStatus", "farmId"])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_FarmPoolStatCards, {
              pool: _ctx.pool,
              loading: _ctx.loadingPool,
              userPools: _ctx.userPools,
              userClaimFlakeStatus: _ctx.userClaimFlakeStatus,
              personal: true,
              farmId: _ctx.farmId
            }, null, 8, ["pool", "loading", "userPools", "userClaimFlakeStatus", "farmId"])
          ])
        ])
      ]),
      (!_ctx.isLiquidityBootstrappingPool)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            (_ctx.loadingPool)
              ? (_openBlock(), _createBlock(_component_BalLoadingBlock, {
                  key: 0,
                  class: "pool-actions-card h-60 mb-4"
                }))
              : true
                ? (_openBlock(), _createBlock(_component_FarmAction, {
                    key: 1,
                    changeType: "stake",
                    class: "mb-5",
                    pool: _ctx.pool,
                    userClaimFlakeStatus: _ctx.userClaimFlakeStatus
                  }, null, 8, ["pool", "userClaimFlakeStatus"]))
                : _createCommentVNode("", true),
            (_ctx.loadingPool)
              ? (_openBlock(), _createBlock(_component_BalLoadingBlock, {
                  key: 2,
                  class: "pool-actions-card h-60 mb-4"
                }))
              : true
                ? (_openBlock(), _createBlock(_component_FarmNavCard, {
                    key: 3,
                    pool: _ctx.pool,
                    data: _ctx.userPools,
                    farmId: _ctx.farmId
                  }, null, 8, ["pool", "data", "farmId"]))
                : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}